import { render, staticRenderFns } from "./SkillAssessment.vue?vue&type=template&id=318bf661&scoped=true"
import script from "./SkillAssessment.vue?vue&type=script&lang=js"
export * from "./SkillAssessment.vue?vue&type=script&lang=js"
import style0 from "./SkillAssessment.vue?vue&type=style&index=0&id=318bf661&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318bf661",
  null
  
)

export default component.exports